document.addEventListener('DOMContentLoaded', () => {
  const headers = document.querySelectorAll('.frame-header');

  headers.forEach(header => {
    header.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const toggle = this.querySelector('.frame-toggle');

      // close others
      document.querySelectorAll('.frame-content').forEach(el => {
        if (el !== content) {
          el.classList.remove('active');
          el.style.maxHeight = null;
        }
      });
      document.querySelectorAll('.frame-toggle').forEach(el => {
        if (el !== toggle) el.classList.remove('active');
      });

      // toggle current
      const isActive = content.classList.toggle('active');
      toggle && toggle.classList.toggle('active', isActive);

      // animate to real height instead of a fixed 2000px
      if (isActive) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = null;
      }
    });
  });
});
